import styled from "styled-components";
import { colors, fonts } from "../../../../GlobalStyle";

export const DateStyle = styled.p`
  font-weight: 400;
  font-size: ${fonts.small};
  line-height: 12px;
  color: ${colors.color76};
  margin-left: 54px;
`;
